/*  MUI  */
import { Button } from '@mui/material';

/*  Okta  */
import { withOktaAuth } from '@okta/okta-react';
import {
    AUTH_POPUP_WINDOW_FEATURES,
    AUTH_POPUP_WINDOW_TARGET
} from 'application/Login/Constants';

/*  Shared  */
import { Browser } from 'application/Shared/Handlers';
import { SessionHelper } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  Objects  */
import Session from 'objects/Session';

/*  React  */
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

class Okta extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { invisibleLogin } = this.props;
        if (invisibleLogin) {
            this.login();
        }
    }

    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        window.removeEventListener('storage', this.handleStorage);
    };

    handleSession = async () => {
        const { setSessionInfo } = this.props;

        const userSession = await Session.getSessionInfo();
        setSessionInfo(userSession);

        const sessionHelper = new SessionHelper(userSession);
        const tenant = sessionHelper.getTenant();

        Browser.handleTabTitle({ tenant });
    };

    handleStorage = (message) => {
        const { key, newValue } = message;

        if (key !== 'jwt') {
            return true;
        }

        if (newValue && newValue !== 'null') {
            window.removeEventListener('storage', this.handleStorage);
            this.handleSession();
            Session.enableOktaSessionValidation(false);
            return true;
        }

        debug.e('Unhandled Value', newValue);
        return true;
    };

    login = () => {
        const { popupWindow } = this.props;
        // Defer session validation until login is successful.
        Session.oktaSessionStarted(false);

        const url = `${window.origin}/okta/login?popup=true`;
        // Use the popup window to avoid being blocked by browsers.
        if (popupWindow) {
            popupWindow.location.href = url;
        } else {
            window.open(
                url,
                AUTH_POPUP_WINDOW_TARGET,
                AUTH_POPUP_WINDOW_FEATURES
            );
        }

        window.addEventListener('storage', (message) =>
            this.handleStorage(message)
        );
    };

    render() {
        const { t, authState, invisibleLogin } = this.props;

        if (!authState || invisibleLogin) {
            return null;
        }

        return (
            <Button
                onClick={() => this.login()}
                color="primary"
                variant="contained"
                style={{
                    height: 40,
                    textTransform: 'uppercase',
                    width: '100%'
                }}
            >
                {t('Login.Okta.button')}
            </Button>
        );
    }
}

export default withTranslation()(withOktaAuth(Okta));
